const radians = (angle) => (angle * Math.PI) / 180

const Block = ({
  context,
  block,
  blockInstance: bi,
  dx,
  dy,
  imageScale,
  xScale,
  yScale,
  transform: t,
  screen,
}) => {
  const cx = dx * t.k + xScale(bi.map.x)
  const cy = dy * t.k + yScale(bi.map.y)
  const w = t.k * imageScale(bi.map.w)
  const h = t.k * imageScale(bi.map.h)

  context.save()
  context.translate(cx, cy)
  context.rotate(radians(bi.map.rotation))
  context.drawImage(block, -w / 2, -h / 2, w, h)
  context.restore()
}

export default Block
